import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { MaskedLine } from "./Reveal";

export const PageHeader = ({ lang, eyebrow, title, breadcrumbs }) => (
  <section className="relative overflow-hidden border-b border-slate-800/60 bg-card/40 py-16 sm:py-20">
    <div className="pointer-events-none absolute -top-32 right-0 h-96 w-96 rounded-full bg-amber-500/10 blur-[120px]" />
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <nav className="mb-5 flex flex-wrap items-center gap-1.5 font-mono text-xs uppercase tracking-[0.2em] text-slate-500" data-testid="breadcrumbs">
        {breadcrumbs.map(([label, to], i) => (
          <span key={i} className="flex items-center gap-1.5">
            {i > 0 && <ChevronRight size={12} className="text-slate-600" />}
            {to ? <Link to={to} className="transition-colors hover:text-amber-400" data-testid={`breadcrumb-${i}`}>{label}</Link> : <span className="text-amber-400">{label}</span>}
          </span>
        ))}
      </nav>
      {eyebrow && <p className="mb-3 font-mono text-xs uppercase tracking-[0.3em] text-amber-400" data-testid="page-eyebrow">{eyebrow}</p>}
      <h1 className="font-display text-4xl font-extrabold tracking-tight sm:text-5xl lg:text-6xl" data-testid="page-h1">
        <MaskedLine>{title}</MaskedLine>
      </h1>
    </div>
  </section>
);
